import { render, staticRenderFns } from "./appAgreement.vue?vue&type=template&id=6890a585&scoped=true&"
import script from "./appAgreement.vue?vue&type=script&lang=js&"
export * from "./appAgreement.vue?vue&type=script&lang=js&"
import style0 from "./appAgreement.vue?vue&type=style&index=0&id=6890a585&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890a585",
  null
  
)

export default component.exports